import React from "react"
import "./TransitionDocument.css"
const ReportIssue=()=>{
    return(
        <div style={{textAlign:"center"}}>
               <h1>Report Issue</h1><br/><br/>
               <h3 style={{textAlign:"center", 
               fontSize:"45px",
    color: "red",
    }} className="blinktext">Coming Soon</h3>
        </div>
    )
}
export default ReportIssue